import { Link } from 'react-router-dom';
import { Settings, Info, ChevronRight } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { PageHeader } from '../components/layout/PageHeader';

const menuItems = [
  {
    to: '/mas/ajustes',
    icon: Settings,
    label: 'Ajustes',
    description: 'Configurar favoritos y preferencias',
    color: 'bg-gray-100 text-gray-600'
  },
  {
    to: '/mas/acerca',
    icon: Info,
    label: 'Acerca de',
    description: 'Información sobre Datacultivo',
    color: 'bg-amber-100 text-amber-600'
  },
];

export function MasPage() {
  return (
    <div className="px-4 py-4" data-testid="mas-page">
      <PageHeader 
        title="Ajustes e información" 
        showBack
      />

      <div className="mt-4 space-y-3">
        {menuItems.map(({ to, icon: Icon, label, description, color }) => (
          <Link key={to} to={to} data-testid={`link-${label.toLowerCase()}`}>
            <Card className="hover:border-primary/50 transition-colors cursor-pointer active:scale-[0.98]">
              <CardContent className="p-4 flex items-center gap-4">
                <div className={`rounded-full p-3 ${color}`}>
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </div>
                <div className="flex-1">
                  <p className="font-medium">{label}</p>
                  <p className="text-sm text-muted-foreground">{description}</p>
                </div>
                <ChevronRight className="h-5 w-5 text-muted-foreground" />
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>

      {/* Version info */}
      <p className="mt-8 text-center text-xs text-muted-foreground">
        Datacultivo v1.0.0
      </p>
    </div>
  );
}

export default MasPage;
